import { Link } from 'react-router-dom';
import { DropCard } from '../components/DropCard';
import { Rail, Slide } from '../components/Rail';
import {
  trendingDrops,
  dropsByChannel,
  dropsByCreator,
  getChannel,
  type Drop,
} from '../data/mock';

/**
 * Home — the personalized magazine, sectioned by source, not a flat stream.
 * No auth yet, so "following" is simulated with a small hardcoded set. Live
 * Drops lead, then a section per followed channel, then per followed creator.
 * See BRAND.md ▸ Home (Personalized).
 */

// Stand-in for the user's subscriptions until follow state is wired.
const FOLLOWED_CHANNELS = ['street-photography', 'meme-culture'];
const FOLLOWED_CREATORS = ['soleau'];

export function Home() {
  const liveDrops = trendingDrops.filter((d) => d.edition.sold < d.edition.total);

  return (
    <main className="min-h-[100dvh] bg-provny-white text-provny-black dark:bg-provny-ink dark:text-provny-white">
      <div className="mx-auto max-w-7xl px-6 pb-20 pt-10">
        <h1 className="font-heading text-4xl font-black tracking-tight sm:text-5xl">Home</h1>

        <Rail label="Live Drops">
          {liveDrops.map((drop) => (
            <Slide key={drop.id} width="w-64">
              <DropCard drop={drop} />
            </Slide>
          ))}
        </Rail>

        {FOLLOWED_CHANNELS.map((slug) => {
          const channel = getChannel(slug);
          const drops = dropsByChannel(slug);
          if (!channel || drops.length === 0) return null;
          return (
            <Rail
              key={slug}
              label={
                <Link to={`/c/${slug}`} className="transition-colors hover:text-provny-cyber-dim dark:hover:text-provny-cyber">
                  From {channel.name}
                </Link>
              }
            >
              {drops.map((drop) => (
                <Slide key={drop.id} width="w-64">
                  <DropCard drop={drop} />
                </Slide>
              ))}
            </Rail>
          );
        })}

        {FOLLOWED_CREATORS.map((handle) => {
          const drops: Drop[] = dropsByCreator(handle);
          if (drops.length === 0) return null;
          return (
            <Rail
              key={handle}
              label={
                <Link to={`/@${handle}`} className="transition-colors hover:text-provny-cyber-dim dark:hover:text-provny-cyber">
                  New from @{handle}
                </Link>
              }
            >
              {drops.map((drop) => (
                <Slide key={drop.id} width="w-64">
                  <DropCard drop={drop} />
                </Slide>
              ))}
            </Rail>
          );
        })}
      </div>
    </main>
  );
}
